<template>
  <div class="crz-container">
    <h2 class="f-24 sz-primary-grey--text font-weight-medium">
      {{ $t('form.consentsTitle') }}
    </h2>
    <p class="prepend-required f-14 sz-secondary-grey--text mb-0">
      {{ $t('label.consentsRequired') }}
    </p>
    <div
      v-for="(field, index) in splittedLabelConsentFields"
      :key="index"
    >
      <div v-if="isCheckbox(field.type)">
        <CheckboxField
          v-model="modelValue[field.name]"
          :label="field.options.label"
          :required="field.options.required === true"
          :name="field.name"
          :rules="field.options.required ? 'required' : ''"
          :details-text="field.options.details"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CheckboxField from '@/components/widgets/Inputs/CheckboxField.vue';
import { useConsentStore } from '@/stores/Consent';
import { computed, defineModel } from 'vue';

const modelValue = defineModel<Record<string, boolean>>({ default: () => ({}) });

const consentStore = useConsentStore();

const splittedLabelConsentFields = computed(() => {
    return consentStore.getSplittedLabelConsentFields;
});

const isCheckbox = (type: string): boolean => type === 'checkbox';
</script>
